import * as Yup from 'yup';

export const MERCHANT_EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const merchantEmailSchema = Yup.string()
  .test('no-leading-space', 'Leading spaces are not allowed', (value) => !/^\s/.test(value ?? ''))
  .matches(MERCHANT_EMAIL_REGEX, 'Enter a valid email address')
  .required('Email is required');

export const isValidMerchantEmail = (email) => MERCHANT_EMAIL_REGEX.test(email?.trim() ?? '');

export const personNameSchema = (label = 'Name') =>
  Yup.string()
    .test(
      'no-spaces',
      `${label} cannot have leading spaces or spaces between characters`,
      (value) => !/\s/.test(value ?? ''),
    )
    .min(2, `${label} must be at least 2 characters`)
    .max(50, `${label} must be at most 50 characters`)
    .required(`${label} is required`);

export const requiredString = (field = 'Field') => Yup.string().required(`${field} is required`);

export const optionalString = () => Yup.string().optional();

export const nameSchema = Yup.string()
  .min(2, 'Name must be at least 2 characters')
  .max(100, 'Name must be at most 100 characters')
  .required('Name is required');

export const phoneFieldSchema = Yup.string().matches(
  /^[+]?[\d\s()-]{10,}$/,
  'Invalid phone number',
);

/**
 * Optional URL check — blank is treated as valid (field is optional).
 * Only http/https URLs are accepted.
 */
export const isValidOptionalUrl = (value) => {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed) return true;

  try {
    const url = new URL(trimmed);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
